<template>
  <section
    class="feedback-attempts-banner"
    :class="{
      'feedback-attempts-banner--low': isLowAttempts,
      'feedback-attempts-banner--pro': isProUser,
      'feedback-attempts-banner--guest': !isAuthenticated
    }"
  >
    <div class="feedback-attempts-main">
      <p class="feedback-attempts-title">Feedback attempts</p>
      <p v-if="showSubtitle" class="feedback-attempts-subtitle">
        Only requesting feedback uses an attempt. Editing is always free.
      </p>
    </div>
    <span class="feedback-attempts-pill">{{ attemptsPillText }}</span>
  </section>
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    remainingAttempts: {
      type: Number,
      default: null
    },
    isAuthenticated: {
      type: Boolean,
      default: true
    },
    isProUser: {
      type: Boolean,
      default: false
    },
    showSubtitle: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const normalizedAttempts = computed(() => {
      const count = Number(props.remainingAttempts);
      if (!Number.isFinite(count)) {
        return null;
      }

      return Math.max(0, Math.floor(count));
    });

    const isLowAttempts = computed(
      () => normalizedAttempts.value !== null && normalizedAttempts.value <= 10
    );

    const attemptsPillText = computed(() => {
      if (props.isProUser) {
        return "Unlimited";
      }

      if (!props.isAuthenticated) {
        return "Sign in";
      }

      if (normalizedAttempts.value === null) {
        return "--";
      }

      return `${normalizedAttempts.value} remaining`;
    });

    return {
      attemptsPillText,
      isLowAttempts
    };
  }
};
</script>

<style scoped>
.feedback-attempts-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 20px;
  border-radius: 20px;
  border: 1px solid #ddd6fe;
  background: #f5f3ff;
}

.feedback-attempts-main {
  min-width: 0;
}

.feedback-attempts-title {
  margin: 0;
  color: #5b21b6;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
}

.feedback-attempts-subtitle {
  margin: 2px 0 0;
  color: #6d28d9;
  font-size: 12px;
  line-height: 1.35;
}

.feedback-attempts-pill {
  flex-shrink: 0;
  border-radius: 999px;
  padding: 0.55rem 1.25rem;
  border: 1px solid #d8b4fe;
  background: #ede9fe;
  color: #6d28d9;
  font-size: 12px;
  font-weight: 800;
}

.feedback-attempts-banner--low {
  border-color: #f6d3a6;
  background: #fff8ed;
}

.feedback-attempts-banner--low .feedback-attempts-pill {
  border-color: #f0c08b;
  color: #9a3412;
}

.feedback-attempts-banner--pro {
  border-color: #ccebd6;
  background: #f4fdf6;
}

.feedback-attempts-banner--pro .feedback-attempts-pill {
  border-color: #b6e3c3;
  color: #166534;
}

.feedback-attempts-banner--guest {
  border-color: #ddd6fe;
  background: #f5f3ff;
}

@media (max-width: 640px) {
  .feedback-attempts-banner {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>